module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/messenger-653a8e7520f561a255446e15a7ad3672.png";